import { Route } from '@angular/router';
import { FuelPreferenceResolver } from '../../../../../common/routing';
import { CurrenciesResolver, UnitsResolver } from '../../../../../common/routing/resolvers';
import { CreateTenderContractsComponent } from '../../../../pages';
import { TenderStepGuard } from '../../../guards';
import { TenderDocumentsResolver, TenderRequestedDocumentsResolver } from '../../../resolvers';

export const createTenderContractsRoute: Route = {
    path: 'locations',
    component: CreateTenderContractsComponent,
    canActivate: [TenderStepGuard],
    resolve: {
        currenciesCollection: CurrenciesResolver,
        unitsCollection: UnitsResolver,
        requestedDocuments: TenderRequestedDocumentsResolver,
        fuelPreferenceCollection: FuelPreferenceResolver,
        importContractsFile: TenderDocumentsResolver, // todo DocumentDownloadResolver
    },
};
